import React from "react";
import { Menu, MenuItem } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import TimelineIcon from "@mui/icons-material/Timeline";

export default function ActionMenu({
  anchorEl,
  onClose,
  onAction,
  selectedOrder,
}) {
  const hasActivity = !!selectedOrder?.notes?.viewed_datasets?.length;

  return (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={onClose}
      anchorOrigin={{ vertical: "top", horizontal: "left" }}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <MenuItem onClick={() => onAction("View Details")}>
        <VisibilityIcon fontSize="small" sx={{ mr: 1 }} /> View Details
      </MenuItem>
      {hasActivity && (
        <MenuItem onClick={() => onAction("View Activity")}>
          <TimelineIcon fontSize="small" sx={{ mr: 1, color: "#1976d2" }} />{" "}
          View Activity
        </MenuItem>
      )}
      <MenuItem onClick={() => onAction("Edit Order")}>
        <EditIcon fontSize="small" sx={{ mr: 1 }} /> Edit Order
      </MenuItem>
      <MenuItem
        onClick={() => onAction("Delete Order")}
        sx={{ color: "#fe0101bb" }}
      >
        <DeleteIcon fontSize="small" sx={{ mr: 1, color: "#fe0101bb" }} />{" "}
        Delete Order
      </MenuItem>
    </Menu>
  );
}
